import { notifications } from "./Notifications.svelte";

export const info = (message) =>
  notifications ? notifications.show(message) : null;

export const danger = (message) =>
  notifications ? notifications.danger(message) : null;
